import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    private readonly httpClient = inject(HttpClient);
    private readonly errorHandlingService = inject(ErrorHandlingService);

    public getBlob(url: string, token: string | undefined): Observable<Blob | undefined> {
        if (!token) {
            return of(undefined);
        }

        return this.httpClient
            .get(url, {
                withCredentials: true,
                responseType: 'blob',
                headers: {
                    ['X-CSRF-Token']: token,
                    ['ngsw-bypass']: 'true',
                },
            })
            .pipe(catchError((err: HttpErrorResponse) => this.errorHandlingService.catchError(err)));
    }
}
